import React, { Suspense } from "react";
import "./App.css";
import "./index.css";
import "./common/common_css/Common_Css.css";
import "./common/common_css/Common_Modal_css.css";
import "./common/common_css/Common_tab_css.css";
import "./common/common_css/Form.css";
import "./common/common_css/Orders.css";
import "./common/common_css/Payments.css";

import { Route, Routes } from "react-router-dom";
import Login from "./components/login/Login";
import { Spinner } from "react-bootstrap";
import DefaultLayout from "./layout/DefaultLayout";
import Device_Warning from "./components/device_warning/Device_Warning";
import Auto_FullScreen from "./components/auto_fullscreen/Auto_FullScreen";

function App() {
  return (
    <>
      <Auto_FullScreen />
      <Device_Warning />
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <Spinner
              animation="grow"
              variant="primary"
              style={{
                width: "4rem",
                height: "4rem",
                color: "#fbca06",
                background: "#fbca06",
              }}
            />
          </div>
        }
      >
        <Routes>
          <Route exact path="/" name="Login Page" element={<Login />} />
          {/* <Route exact path="/404" name="Page 404" element={<Page404 />} /> */}
          {/* <Route exact path="/500" name="Page 500" element={<Page500 />} /> */}
          <Route path="*" name="Home" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
